<template>
  <div class="mt-2">
    <v-card>
      <v-toolbar
        dense
        color="white"
        class="elevation-0"
      >
        <v-toolbar-title>
          <v-icon>mdi-chart-pie</v-icon>
          נצילות
        </v-toolbar-title>
      </v-toolbar>
      <v-divider />
      <v-card-text>
        <v-progress-linear
          indeterminate
          height="2"
          v-if="fetching"
        ></v-progress-linear>
        <template>
          <v-chart
            :options="chart"
            :autoresize="true"
          />
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/pie";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";

import { format } from "date-fns";
import Mixins from "@/mixins/mixins";
// import { getApi } from "@/api";
// import shouldShow from "@/utils/shouldShow";

export default {
  data() {
    return {
      fetching: false,
      fromDate: new Date("2018-06-01"),
      toDate: new Date(),
      reportData: [],
      chart: {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          x: "left",
          data: ["למטייל", "לקוח", "משרד"]
        },
        series: [
          {
            name: "מיקום מכשיר",
            type: "pie",
            radius: ["50%", "70%"],
            // avoidLabelOverlap: false,
            // label: {
            //   normal: {
            //     show: false,
            //     position: "center"
            //   },
            //   emphasis: {
            //     show: true,
            //     textStyle: {
            //       fontSize: "25",
            //       fontWeight: "bold"
            //     }
            //   }
            // },
            // labelLine: {
            //   normal: {
            //     show: true
            //   }
            // },
            data: [
              { value: 335, name: "למטייל" },
              { value: 310, name: "לקוח" },
              { value: 234, name: "משרד" }
            ]
          }
        ]
      }
    };
  },
  methods: {
    format,
    fetch() {
      // this.fetching = true;
      // let params = {
      //   fromDate: this.fromDate,
      //   toDate: this.toDate
      // };
      // getApi()
      //   .then(api => {
      //     return api.get("/reports/device-efficiency", params);
      //   })
      //   .catch(err => {
      //     this.$store.dispatch("SHOW_SNACKBAR", {
      //       text: err.message,
      //       color: "error"
      //     });
      //   })
      //   .finally(() => {
      //     this.fetching = false;
      //   });
    }
  },
  computed: {},
  props: ["device"],
  watch: {},
  mounted() {
    this.fetch();
  },
  components: {
    "v-chart": ECharts
  },
  mixins: [Mixins]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.echarts {
  width: 100%;
  height: 400px;
}
</style>